import { ajax } from "@/assets/js/ajax";
export function getSubject(data) {     //案件主体列表
  return ajax({
    url: 'accuser/index',
    type: 'get',
    data: data
  })
}

export function accuserInfo(data) {     //原告详情
  return ajax({
    url: 'accuser/info',
    type: 'get',
    data: data
  })
}

export function accuserEdit(data) {     //原告修改 //2026-03-19废弃
  return ajax({
    url: 'accuser/edit',
    type: 'post',
    data: data
  })
}

export function accuserAdd(data) {     //原告添加 //2026-03-19废弃
  return ajax({
    url: 'accuser/add',
    type: 'post',
    data: data
  })
}

export function plaintiffAdd(data) {     //添加原告
  return ajax({
    url: 'debtor/add_debtor',
    type: 'post',
    data: data
  })
}

export function plaintiffEdit(data) {     //修改原告
  return ajax({
    url: 'debtor/edit_debtor',
    type: 'post',
    data: data
  })
}

export function accuserdebtorlists(data) {     //个人原告
  return ajax({
    url: 'debtor/accuser_debtor_lists', 
    type: 'get',
    data: data
  })
}
